<ng-container [ngSwitch]="orderItemStatus">
  <ng-container *ngSwitchCase="OrderItemStatus.Fulfilled">
    <rd-shared-icon
      class="mx-auto mt-0 mb-8"
      [iconSymbol]="'icon-success'"
      [iconTheme]="'success'"></rd-shared-icon>
    <h1
      class="transfer-status-text confirmed mt-0 mb-6"
      [attr.aria-live]="'polite'">
      {{ 'transfer_v2.success.status_text_confirmed' | translate }}
    </h1>
    <p
      class="transfer-order-id mt-0 mb-6"
      [innerHTML]="
        'transfer_v2.success.order_id' | translate: orderIdParams
      "></p>
  </ng-container>

  <ng-container *ngSwitchCase="OrderItemStatus.Pending">
    <rd-shared-icon
      class="mx-auto mt-0 mb-8"
      [iconSymbol]="'icon-progress'"
      [iconTheme]="'warn'"></rd-shared-icon>
    <h1
      class="transfer-status-text pending mt-0 mb-6"
      [attr.aria-live]="'polite'">
      {{ 'transfer_v2.success.status_text_pending' | translate }}
    </h1>
    <p
      class="transfer-order-id mt-0 mb-6"
      [innerHTML]="
        'transfer_v2.success.order_id' | translate: orderIdParams
      "></p>
    <p
      class="transfer-disclaimer mt-0 mb-6"
      [innerHTML]="
        'transfer_v2.success.notification_disclaimer' | translate
      "></p>
  </ng-container>

  <ng-container *ngSwitchCase="OrderItemStatus.Cancelled">
    <rd-shared-icon
      class="mx-auto mt-0 mb-8"
      [iconSymbol]="'icon-error'"
      [iconTheme]="'error'"></rd-shared-icon>
    <h1
      class="transfer-status-text failed mt-0 mb-6"
      [attr.aria-live]="'polite'">
      {{ 'transfer_v2.success.status_text_failed' | translate }}
    </h1>
    <p
      class="transfer-order-id mt-0 mb-6"
      [innerHTML]="
        'transfer_v2.success.order_id' | translate: orderIdParams
      "></p>
    <p
      class="transfer-disclaimer mt-0 mb-6"
      [innerHTML]="'transfer_v2.success.contact_us' | translate"></p>
  </ng-container>
</ng-container>
